import { render, staticRenderFns } from "./CongelationExpedition.vue?vue&type=template&id=6e6b8d9b&"
import script from "./CongelationExpedition.vue?vue&type=script&lang=js&"
export * from "./CongelationExpedition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports